import React, { Component } from "react";
import {
  company,
  loading,
  NavbarAdmin,
  Modal,
  Select,
  DatePicker,
  DateRangeFields,
  currentLang,
  Pagination,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  format_date,
  t,
  searchCustomerRows,
  mergeCustomerPins,
  addCustomerPin,
  ActionIconButton,
  ACTION_ICONS,
} from "../../components/CustomComponent.js";
import { can } from "../../utils/permission.js";
import { formatNumber } from "../../utils/formatting";

/**
 * Sales Visit Planning — เชื่อมต่อ API จริง (admin/sale-plannings)
 * Master ที่ใช้: admin/sale-masters (Sales), admin/customers (ลูกค้า), admin/objectives (วัตถุประสงค์)
 * รองรับเปลี่ยนภาษา th/en ผ่าน t()
 */

const I = (code) => String.fromCharCode(code);
const IC = {
  calendar: I(0xf073),
  plus: I(0xf067),
  table: I(0xf0ce),
  user: I(0xf007),
  users: I(0xf0c0),
  sparkle: I(0xf0d0),
  excel: I(0xf1c3),
  eye: I(0xf06e),
  save: I(0xf0c7),
  info: I(0xf05a),
  check: I(0xf00c),
  pin: I(0xf3c5),
  hourglass: I(0xf254),
  warning: I(0xf071),
  chkCircle: I(0xf058),
  search: I(0xf002),
  chevL: I(0xf053),
  chevR: I(0xf054),
};

export default class SalesVisitPlanning extends Component {
  constructor(props) {
    super(props);
    const now = new Date();
    const todayIso = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
    this.state = {
      dashboard_view: "calendar", // 'calendar' | 'table'

      // calendar
      cal_mode: "week", // 'day' | 'week' | 'month'
      cal_anchor: todayIso, // วันอ้างอิงของช่วงที่แสดง
      cal_data: [], // นัดทั้งหมด (สำหรับปฏิทิน)

      // list + paging
      data: [],
      count: 0,
      page: 1,
      page_size: 10,

      // relation options
      data_sales: [],
      data_customers: [],
      data_objectives: [],
      customer_map: {}, // uid -> customer detail (auto-fill)
      customer_pins: [], // ลูกค้าที่ถูกอ้างถึงอยู่ ต้องคงไว้ในรายการแม้ผลค้นหาจะเปลี่ยน

      // filters
      filter_sales: "",
      filter_customer: "",
      filter_status: "",
      filter_date_start: "",
      filter_date_end: "",

      // create/edit modal
      modal_create: false,
      modal_update: false,
      uid: "",
      customer_type: "existing", // 'existing' | 'prospect'
      f_sale_id: "",
      f_customer_id: "",
      f_customer_name: "",
      f_business_type: "",
      f_contact_name: "",
      f_contact_phone: "",
      f_address: "",
      f_appointment_date: "",
      f_appointment_time: "",
      f_appointment_time_end: "",
      f_objective_id: "",
      f_reference: "",
      f_description: "",
      f_status: "waiting",
    };
  }

  componentDidMount() {
    loading(false);
    this.GetReferenceData();
    this.Get(1);
  }

  // ข้อมูลอ้างอิงสำหรับ dropdown: โหลดครั้งเดียวตอนเข้าหน้า ไม่โหลดซ้ำทุกครั้งที่เปลี่ยนหน้า/กรอง
  GetReferenceData = async () => {
    // ลูกค้าไม่โหลดยกก้อน - ค้นหาฝั่ง server ตอนพิมพ์ (SearchCustomers)
    const [resSales, resObjectives] = await Promise.all([
      GET("admin/sale-masters", { page_size: 1000, page: 0 }),
      GET("admin/objectives", { page_size: 1000, page: 0 }),
    ]);

    const sales = this.normalizeArray(resSales?.data).map((s) => ({
      value: s.uid,
      label: [s.name_th || s.name_en, s.sale_code ? `(${s.sale_code})` : ""].filter(Boolean).join(" "),
    }));

    const objectives = this.normalizeArray(resObjectives?.data).map((o) => ({
      value: o.uid,
      label: o.name || o.code || "-",
    }));

    this.setState({
      data_sales: sales,
      data_objectives: objectives,
    });

    this.SearchCustomers("");
  };

  toCustomerOption = (customer) => ({
    ...customer,
    value: customer.uid,
    label: customer.full_name_th || customer.full_name_en || customer.customer_code || "-",
  });

  // ค้นหาลูกค้าฝั่ง server (Select เรียกให้ตอนพิมพ์) - token กันผลลัพธ์ที่ตอบช้ามาทับคำค้นล่าสุด
  customerSearchToken = 0;

  SearchCustomers = async (keyword = "") => {
    const token = ++this.customerSearchToken;
    const rows = await searchCustomerRows(keyword);
    if (token !== this.customerSearchToken || rows === null) return;

    this.setState((prevState) => {
      const data_customers = mergeCustomerPins(rows.map(this.toCustomerOption), prevState.customer_pins);
      return { data_customers, customer_map: this.buildCustomerMap(prevState.customer_map, data_customers) };
    });
  };

  // เก็บรายละเอียดลูกค้าที่เคยเห็นไว้ (auto-fill ที่อยู่/ผู้ติดต่อ) ผลค้นหารอบใหม่จะไม่ลบของเดิมทิ้ง
  buildCustomerMap = (currentMap = {}, options = []) => {
    const next = { ...currentMap };
    options.forEach((option) => { next[option.value] = option; });
    return next;
  };

  // ปักหมุดลูกค้าที่เลือกไว้ ไม่ให้หายไปจากรายการเมื่อผลค้นหาเปลี่ยน
  pinCustomer = (option) => {
    if (!option?.value) return;

    this.setState((prevState) => {
      const customer_pins = addCustomerPin(prevState.customer_pins, option);
      const data_customers = mergeCustomerPins(prevState.data_customers, customer_pins);
      return { customer_pins, data_customers, customer_map: this.buildCustomerMap(prevState.customer_map, data_customers) };
    });
  };

  normalizeArray = (payload) => {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.data)) return payload.data;
    if (payload && typeof payload === "object") return [payload];
    return [];
  };

  // "HH:MM" / "HH:MM:SS" -> นาที (null ถ้าไม่มี)
  timeToMin = (tStr) => {
    if (!tStr) return null;
    const m = String(tStr).match(/^(\d{1,2}):(\d{2})/);
    return m ? Number(m[1]) * 60 + Number(m[2]) : null;
  };

  // status -> badge view
  statusView = {
    visited: { labelKey: "svp_st_visited", icon: IC.check, cls: "bg-success-light text-success border border-success" },
    checkin: { labelKey: "svp_st_checkin", icon: IC.pin, cls: "bg-primary-light text-primary border border-primary" },
    waiting: { labelKey: "svp_st_pending", icon: IC.hourglass, cls: "text-warning border border-warning", style: { backgroundColor: "#FEF3C7" } },
    no_checkin: { labelKey: "svp_st_no_checkin", icon: IC.warning, cls: "text-danger border border-danger", style: { backgroundColor: "#FEE2E2" } },
  };

  statusOptions = () => [
    { value: "waiting", label: t("svp_st_pending") },
    { value: "checkin", label: t("svp_st_checkin") },
    { value: "visited", label: t("svp_st_visited") },
    { value: "no_checkin", label: t("svp_st_no_checkin") },
  ];

  Get = async (page) => {
    const { filter_sales, filter_customer, filter_status, filter_date_start, filter_date_end, page_size } = this.state;
    loading(true);

    const [resList, resCalAll] = await Promise.all([
      GET("admin/sale-plannings", {
        page,
        page_size,
        sale_id: filter_sales || "",
        customer_id: filter_customer || "",
        status: filter_status || "",
        appointment_date_from: filter_date_start || "",
        appointment_date_to: filter_date_end || "",
      }),
      // ดึงทั้งหมด (page 0) สำหรับปฏิทิน — ใช้ filter เดียวกันยกเว้นวันที่
      GET("admin/sale-plannings", {
        page: 0,
        page_size: 1000,
        sale_id: filter_sales || "",
        customer_id: filter_customer || "",
        status: filter_status || "",
      }),
    ]);

    this.setState({
      data: resList?.status ? this.normalizeArray(resList.data) : [],
      count: resList?.pagination?.count || 0,
      cal_data: resCalAll?.status ? this.normalizeArray(resCalAll.data) : [],
      page,
    });
    loading(false);
  };

  resetFilters = () =>
    this.setState({ filter_sales: "", filter_customer: "", filter_status: "", filter_date_start: "", filter_date_end: "" }, () => this.Get(1));

  openCreate = () =>
    this.setState({
      modal_create: true, modal_update: false,
      uid: "", customer_type: "existing",
      f_sale_id: "", f_customer_id: "", f_customer_name: "", f_business_type: "",
      f_contact_name: "", f_contact_phone: "", f_address: "",
      f_appointment_date: "", f_appointment_time: "", f_appointment_time_end: "",
      f_objective_id: "", f_reference: "", f_description: "", f_status: "waiting",
    });

  openEdit = (item) => {
    // ลูกค้าของแผนนี้อาจไม่อยู่ในผลค้นหาปัจจุบัน ปักหมุดไว้ให้ dropdown แสดงชื่อได้
    if (item.customer?.uid) this.pinCustomer(this.toCustomerOption(item.customer));

    this.setState({
      modal_create: false, modal_update: true,
      uid: item.uid,
      customer_type: item.customer_type === "prospect" ? "prospect" : "existing",
      f_sale_id: item.sale?.uid || "",
      f_customer_id: item.customer?.uid || "",
      f_customer_name: item.customer_name || "",
      f_business_type: item.business_type || "",
      f_contact_name: item.contact_name || "",
      f_contact_phone: item.contact_phone || "",
      f_address: item.address || "",
      f_appointment_date: item.appointment_date || "",
      f_appointment_time: (item.appointment_time || "").slice(0, 5),
      f_appointment_time_end: (item.appointment_time_end || "").slice(0, 5),
      f_objective_id: item.objective?.uid || "",
      f_reference: item.reference || "",
      f_description: item.description || "",
      f_status: item.status || "waiting",
    });
  };

  closeModal = () => this.setState({ modal_create: false, modal_update: false });

  handleSave = async () => {
    const s = this.state;
    const isProspect = s.customer_type === "prospect";

    // validate
    if (!s.f_sale_id) { alert("", "warning", t("warning"), t("svp_validate_sales")); return; }
    if (isProspect && !s.f_customer_name.trim()) { alert("", "warning", t("warning"), t("svp_validate_company")); return; }
    if (!isProspect && !s.f_customer_id) { alert("", "warning", t("warning"), t("svp_validate_customer")); return; }
    if (!s.f_appointment_date) { alert("", "warning", t("warning"), t("svp_validate_date")); return; }
    if (!s.f_objective_id) { alert("", "warning", t("warning"), t("svp_validate_objective")); return; }
    if (s.f_description.trim().length < 30) { alert("", "warning", t("warning"), t("svp_validate_remark")); return; }

    // 1) ห้ามเลือกวันย้อนหลัง
    const now = new Date();
    const todayIso = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
    if (s.f_appointment_date < todayIso) { alert("", "warning", t("warning"), t("svp_validate_past_date")); return; }

    // 2) เวลาสิ้นสุด ≤ เวลาเริ่ม
    const startMin = this.timeToMin(s.f_appointment_time);
    const endMin = this.timeToMin(s.f_appointment_time_end);
    if (startMin != null && endMin != null && endMin <= startMin) {
      alert("", "warning", t("warning"), t("svp_validate_time_range"));
      return;
    }

    // ดึงรายการนัดวันเดียวกัน (ไม่รวมตัวที่กำลังแก้) เพื่อตรวจเวลาซ้อน / ลูกค้าซ้ำ
    loading(true);
    const dayRes = await GET("admin/sale-plannings", { page: 0, page_size: 1000, appointment_date: s.f_appointment_date });
    const dayPlans = this.normalizeArray(dayRes?.data).filter((p) => p.uid !== s.uid);
    loading(false);

    // 3) เวลาซ้อนกับนัดอื่น (ของ Sales คนเดียวกัน)
    let overlap = false;
    if (startMin != null && endMin != null) {
      overlap = dayPlans.some((p) => {
        if (p.sale?.uid && s.f_sale_id && p.sale.uid !== s.f_sale_id) return false;
        const ps = this.timeToMin(p.appointment_time);
        const pe = this.timeToMin(p.appointment_time_end);
        if (ps == null || pe == null) return false;
        return startMin < pe && ps < endMin;
      });
    }

    // 4) ลูกค้าซ้ำในวันเดียวกัน
    const duplicate = dayPlans.some((p) =>
      isProspect
        ? !!s.f_customer_name.trim() && (p.customer_name || "").trim() === s.f_customer_name.trim()
        : !!s.f_customer_id && p.customer?.uid === s.f_customer_id
    );

    // รวมข้อความเตือน → confirm ครั้งเดียว (ถ้าไม่มีเตือนใช้ confirm ปกติ)
    const warns = [];
    if (overlap) warns.push(t("svp_confirm_overlap"));
    if (duplicate) warns.push(t("svp_confirm_duplicate"));
    const confirmMsg = warns.length ? warns.join("\n") : t("confirm_submission");

    if (!(await alert("", warns.length ? "warning" : "info", t("confirm"), confirmMsg, t("confirm"), t("cancel")))) return;

    loading(true);
    const body = {
      company_id: company?.id || "",
      sale_id: s.f_sale_id || "",
      customer_type: s.customer_type,
      customer_id: isProspect ? "" : (s.f_customer_id || ""),
      customer_name: isProspect ? s.f_customer_name : "",
      business_type: isProspect ? s.f_business_type : "",
      contact_name: isProspect ? s.f_contact_name : "",
      contact_phone: isProspect ? s.f_contact_phone : "",
      address: isProspect ? s.f_address : "",
      appointment_date: s.f_appointment_date || "",
      appointment_time: s.f_appointment_time || "",
      appointment_time_end: s.f_appointment_time_end || "",
      objective_id: s.f_objective_id || "",
      reference: s.f_reference || "",
      description: s.f_description || "",
      status: s.f_status || "waiting",
      is_active: true,
    };

    const result = !s.uid
      ? await POST("admin/sale-plannings", body)
      : await PUT("admin/sale-plannings/" + s.uid, body);

    if (result?.status === true) {
      alert("#", "success", t("success"), t("save_success"));
      this.closeModal();
      this.Get(this.state.page);
    } else {
      alert("", "warning", t("warning"), result?.message || "An error occurred.");
    }
    loading(false);
  };

  handleDelete = async (uid) => {
    if (!(await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel")))) return;
    loading(true);
    const result = await DELETE("admin/sale-plannings/" + uid, null);
    if (result?.status) {
      alert("#", "success", t("success"), t("delete_success"));
      this.Get(this.state.page);
    } else {
      alert("", "warning", t("warning"), result?.message || "An error occurred.");
    }
    loading(false);
  };

  // ---------- display helpers ----------
  fmtDate = (d) => (d ? format_date(d, "dd/mm/yyyy", "th") : "-");
  fmtTimeRange = (a, b) => {
    const s = (a || "").slice(0, 5);
    const e = (b || "").slice(0, 5);
    if (s && e) return `${s}-${e}`;
    return s || "-";
  };
  customerLabel = (item) =>
    item.customer_type === "prospect"
      ? item.customer_name || "-"
      : item.customer?.full_name_th || item.customer?.full_name_en || item.customer_name || "-";
  saleLabel = (item) => item.sale?.name_th || item.sale?.name_en || item.sale?.sale_code || "-";

  render() {
    const { dashboard_view } = this.state;
    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarAdmin />
        <div className="body p-4 mt-3">
          {/* Header */}
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-3">
            <h4 className="fw-bold text-dark mb-0 d-flex align-items-center">
              <span className="icon me-2 text-primary">{IC.calendar}</span> {t("sales_visit_planning")}
            </h4>
            {can("sale-planning.create") ? (
            <button
              className="btn btn-primary px-3 py-2 rounded-3 fw-bold shadow-sm d-flex align-items-center"
              onClick={this.openCreate}
            >
              <span className="icon me-2">{IC.plus}</span> {t("svp_new_plan")}
            </button>
            ) : null}
          </div>

          {this.renderDashboard(dashboard_view)}
        </div>

        {this.renderCreateModal()}
      </div>
    );
  }

  renderDashboard(dashboard_view) {
    const { data, count } = this.state;
    const countBy = (st) => data.filter((d) => d.status === st).length;
    const kpis = [
      { icon: IC.calendar, color: "#2563eb", border: "#2563eb", label: t("svp_kpi_week"), value: formatNumber(count) },
      { icon: IC.chkCircle, color: "#16a34a", border: "#16a34a", label: t("svp_kpi_visited"), value: formatNumber(countBy("visited")) },
      { icon: IC.hourglass, color: "#ea580c", border: "#ea580c", label: t("svp_kpi_pending"), value: formatNumber(countBy("waiting")) },
      { icon: IC.warning, color: "#dc2626", border: "#dc2626", label: t("svp_kpi_no_checkin"), value: formatNumber(countBy("no_checkin")) },
    ];

    return (
      <>
        {/* KPI Cards */}
        <div className="row g-3 mb-3">
          {kpis.map((kpi, i) => (
            <div className="col-12 col-sm-6 col-xl-3" key={i}>
              <div className="bg-white rounded-4 p-3 shadow-sm h-100" style={{ borderLeft: `4px solid ${kpi.border}` }}>
                <div className="text-secondary text-13 mb-2 d-flex align-items-center">
                  <span className="icon me-2" style={{ color: kpi.color }}>{kpi.icon}</span> {kpi.label}
                </div>
                <div className="fw-bold text-dark" style={{ fontSize: "30px", lineHeight: 1 }}>{kpi.value}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Filter toolbar */}
        <div className="rounded-4 bg-white p-3 mb-3 shadow-sm border-0">
          <div className="row g-2 align-items-center">
            <div className="col-12 col-sm-6 col-lg-2">
              <Select
                className="form-control rounded-3 text-dark"
                options={this.state.data_sales}
                value={this.state.filter_sales}
                onChange={(value) => this.setState({ filter_sales: value })}
                placeholder={t("svp_ph_sales")}
              />
            </div>
            <div className="col-12 col-sm-6 col-lg-2">
              <Select
                className="form-control rounded-3 text-dark"
                options={this.state.data_customers}
                onSearch={this.SearchCustomers}
                value={this.state.filter_customer}
                onChange={(value, item) => {
                  this.pinCustomer(item);
                  this.setState({ filter_customer: value });
                }}
                placeholder={t("svp_ph_customer")}
              />
            </div>
            <div className="col-12 col-sm-6 col-lg-2">
              <Select
                className="form-control rounded-3 text-dark"
                options={this.statusOptions()}
                value={this.state.filter_status}
                onChange={(value) => this.setState({ filter_status: value })}
                placeholder={t("svp_ph_status")}
              />
            </div>
            <div className="col-12 col-lg-3">
              <div className="d-flex gap-2">
                <DateRangeFields
                  type={currentLang()}
                  className="form-control rounded-3"
                  fieldStyle={{ flex: 1, minWidth: 0 }}
                  startPlaceholder={t("start_date")}
                  endPlaceholder={t("end_date")}
                  startValue={this.state.filter_date_start}
                  endValue={this.state.filter_date_end}
                  onChange={({ start, end }) => this.setState({ filter_date_start: start, filter_date_end: end })}
                />
              </div>
            </div>
            <div className="col-12 col-lg-auto ms-lg-auto d-flex gap-2 justify-content-end">
              <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm text-nowrap" onClick={() => this.Get(1)}>
                {t("filter")}
              </button>
              <button className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm text-nowrap" onClick={this.resetFilters}>
                {t("clear_all")}
              </button>
            </div>
          </div>
        </div>

        {/* View toggle */}
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
          <div className="bg-white rounded-3 p-1 shadow-sm d-inline-flex gap-1 border">
            {[
              { key: "calendar", icon: IC.calendar, label: t("svp_calendar_view") },
              { key: "table", icon: IC.table, label: t("svp_table_view") },
            ].map((v) => {
              const active = dashboard_view === v.key;
              return (
                <button
                  key={v.key}
                  className={`btn btn-sm px-3 fw-bold d-flex align-items-center ${active ? "btn-primary text-white" : "btn-white text-dark"}`}
                  onClick={() => this.setState({ dashboard_view: v.key })}
                >
                  <span className="icon me-2">{v.icon}</span> {v.label}
                </button>
              );
            })}
          </div>
        </div>

        {dashboard_view === "table" ? this.renderTableView() : this.renderCalendarView()}
      </>
    );
  }

  renderTableView() {
    const { data, count, page, page_size } = this.state;
    const headers = ["#", t("svp_col_datetime"), t("svp_col_sales"), t("svp_col_customer"), t("svp_col_type"), t("svp_col_objective"), t("svp_col_status"), t("svp_col_remark"), t("svp_col_action")];
    const start = (page - 1) * page_size;

    return (
      <div className="bg-white rounded-4 shadow-sm overflow-hidden mb-3">
        <div className="table-responsive">
          <table className="table align-middle mb-0">
            <thead>
              <tr style={{ backgroundColor: "#1e3a5f" }}>
                {headers.map((h, i) => (
                  <th key={i} className="fw-bold text-13 py-3 px-3 text-nowrap">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.length === 0 ? (
                <tr><td colSpan={headers.length} className="text-center text-secondary py-5">{t("no_data_found")}</td></tr>
              ) : (
                data.map((item, idx) => {
                  const sv = this.statusView[item.status] || this.statusView.waiting;
                  const isProspect = item.customer_type === "prospect";
                  return (
                    <tr key={item.uid || idx} className="border-bottom">
                      <td className="px-3 text-secondary">{start + idx + 1}</td>
                      <td className="px-3 text-nowrap">
                        <div className="fw-bold text-dark text-14">{this.fmtDate(item.appointment_date)}</div>
                        <div className="text-secondary text-12">{this.fmtTimeRange(item.appointment_time, item.appointment_time_end)}</div>
                      </td>
                      <td className="px-3 text-dark text-14 text-nowrap">{this.saleLabel(item)}</td>
                      <td className="px-3 text-dark text-14">{this.customerLabel(item)}</td>
                      <td className="px-3">
                        <span className={`badge rounded-pill px-3 py-1 text-12 ${isProspect ? "bg-primary-light text-primary" : "bg-light text-secondary border"}`}>
                          {isProspect ? t("svp_type_new") : t("svp_type_old")}
                        </span>
                      </td>
                      <td className="px-3 text-dark text-14">{item.objective?.name || "-"}</td>
                      <td className="px-3 text-nowrap">
                        <span className={`badge rounded-pill px-3 py-1 text-12 fw-bold ${sv.cls}`} style={sv.style}>
                          <span className="icon me-1">{sv.icon}</span> {t(sv.labelKey)}
                        </span>
                      </td>
                      <td className="px-3 text-secondary text-14">
                        <div className="text-truncate" style={{ maxWidth: "220px" }} title={item.description || ""}>
                          {item.description || "-"}
                        </div>
                      </td>
                      <td className="px-3 text-nowrap">
                        <div className="d-flex align-items-center gap-2 justify-content-start">
                          <ActionIconButton label={can("sale-planning.update") ? t("edit") : t("view")} icon={can("sale-planning.update") ? ACTION_ICONS.edit : ACTION_ICONS.view} variant={can("sale-planning.update") ? "warning" : "primary"} onClick={() => this.openEdit(item)} />
                          {can("sale-planning.delete") ? (
                          <ActionIconButton label={t("delete")} icon={ACTION_ICONS.delete} variant="danger" onClick={() => this.handleDelete(item.uid)} />
                          ) : null}
                        </div>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
        <div className="d-flex justify-content-between align-items-center px-3 py-3 border-top flex-wrap text-secondary text-12 gap-2">
          <div>{t("showing")} {count === 0 ? 0 : formatNumber(start + 1)}-{formatNumber(start + data.length)} {t("of")} {formatNumber(count)}</div>
          <Pagination
            className="mb-0"
            count={Math.ceil(count / page_size) || 1}
            page={page}
            showFirstButton={false}
            showLastButton={false}
            onChange={(_, p) => this.Get(p)}
          />
        </div>
      </div>
    );
  }

  // ---------- calendar helpers ----------
  eventColors = {
    blue: { bg: "#EAF2FE", bar: "#2563eb", text: "#1e40af" },
    green: { bg: "#E7F6EC", bar: "#16a34a", text: "#15803d" },
    orange: { bg: "#FEF3E2", bar: "#ea580c", text: "#c2410c" },
    red: { bg: "#FDECEC", bar: "#dc2626", text: "#b91c1c" },
    purple: { bg: "#F3EAFE", bar: "#7c3aed", text: "#6d28d9" },
  };

  thMonths = [t("svp_month_jan"), t("svp_month_feb"), t("svp_month_mar"), t("svp_month_apr"), t("svp_month_may"), t("svp_month_jun"), t("svp_month_jul"), t("svp_month_aug"), t("svp_month_sep"), t("svp_month_oct"), t("svp_month_nov"), t("svp_month_dec")];
  weekdayKeys = ["svp_sun", "svp_mon", "svp_tue", "svp_wed", "svp_thu", "svp_fri", "svp_sat"];

  isoOf = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  parseIso = (iso) => {
    const [y, m, dd] = (iso || this.isoOf(new Date())).split("-").map(Number);
    return new Date(y, m - 1, dd);
  };
  addDays = (d, n) => { const x = new Date(d); x.setDate(d.getDate() + n); return x; };
  startHourOf = (tStr) => { const m = this.timeToMin(tStr); return m == null ? null : Math.floor(m / 60); };

  calColor = (name) => {
    const n = (name || "").toLowerCase();
    if (n.includes("demo")) return "green";
    if (n.includes("follow")) return "orange";
    if (n.includes("ร้องเรียน") || n.includes("complaint")) return "red";
    if (n.includes("อบรม") || n.includes("training")) return "purple";
    return "blue";
  };

  isoWeekNo = (date) => {
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const dayNum = (d.getUTCDay() + 6) % 7;
    d.setUTCDate(d.getUTCDate() - dayNum + 3);
    const firstThursday = new Date(Date.UTC(d.getUTCFullYear(), 0, 4));
    return 1 + Math.round(((d - firstThursday) / 86400000 - 3 + ((firstThursday.getUTCDay() + 6) % 7)) / 7);
  };

  calShift = (dir) => {
    const anchor = this.parseIso(this.state.cal_anchor);
    let next;
    if (this.state.cal_mode === "day") next = this.addDays(anchor, dir);
    else if (this.state.cal_mode === "week") next = this.addDays(anchor, dir * 7);
    else { next = new Date(anchor); next.setMonth(anchor.getMonth() + dir); }
    this.setState({ cal_anchor: this.isoOf(next) });
  };
  calToday = () => this.setState({ cal_anchor: this.isoOf(new Date()) });

  // วันจันทร์-ศุกร์ ของสัปดาห์ที่ anchor อยู่ (week) หรือวันเดียว (day)
  calPeriodDates = () => {
    const anchor = this.parseIso(this.state.cal_anchor);
    if (this.state.cal_mode === "day") return [anchor];
    const day = anchor.getDay();
    const monday = this.addDays(anchor, day === 0 ? -6 : 1 - day);
    return [0, 1, 2, 3, 4].map((i) => this.addDays(monday, i));
  };

  calRangeLabel = () => {
    const anchor = this.parseIso(this.state.cal_anchor);
    if (this.state.cal_mode === "day") {
      return format_date(anchor, "dd/mm/yyyy");
    }
    if (this.state.cal_mode === "month") {
      return `${this.thMonths[anchor.getMonth()]} ${anchor.getFullYear()}`;
    }
    const dates = this.calPeriodDates();
    const a = dates[0], b = dates[dates.length - 1];
    return `${format_date(a, "dd/mm/yyyy")} - ${format_date(b, "dd/mm/yyyy")} (${t("svp_week_no")} ${this.isoWeekNo(anchor)})`;
  };

  // Calendar — time-grid (day/week) หรือ month grid
  renderCalendarView() {
    const { cal_mode } = this.state;
    return (
      <div className="bg-white rounded-4 shadow-sm mb-3 p-3">
        {/* header */}
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
          <div className="d-flex align-items-center gap-2">
            <button className="btn btn-sm btn-white border text-dark" onClick={() => this.calShift(-1)}><span className="icon">{IC.chevL}</span></button>
            <span className="fw-bold text-dark text-16">{this.calRangeLabel()}</span>
            <button className="btn btn-sm btn-white border text-dark" onClick={() => this.calShift(1)}><span className="icon">{IC.chevR}</span></button>
            <button className="btn btn-sm btn-white border text-dark ms-2" onClick={this.calToday}>{t("svp_today")}</button>
          </div>
          <div className="bg-light rounded-3 p-1 d-inline-flex gap-1 border">
            {[["day", "svp_view_day"], ["week", "svp_view_week"], ["month", "svp_view_month"]].map(([m, k]) => (
              <button
                key={m}
                className={`btn btn-sm px-3 fw-bold ${cal_mode === m ? "btn-primary text-white" : "btn-white text-dark"}`}
                onClick={() => this.setState({ cal_mode: m })}
              >
                {t(k)}
              </button>
            ))}
          </div>
        </div>

        {cal_mode === "month" ? this.renderCalMonth() : this.renderCalGrid()}

        {/* Legend */}
        <div className="d-flex flex-wrap gap-3 mt-3 text-12">
          {[
            { c: "blue", l: t("svp_lg_quote") },
            { c: "green", l: t("svp_lg_demo") },
            { c: "orange", l: t("svp_lg_followup") },
            { c: "red", l: t("svp_lg_complaint") },
            { c: "purple", l: t("svp_lg_training") },
          ].map((leg) => (
            <div key={leg.l} className="d-flex align-items-center">
              <span className="d-inline-block rounded me-2" style={{ width: 12, height: 12, backgroundColor: this.eventColors[leg.c].bar }}></span>
              <span className="text-dark">{leg.l}</span>
            </div>
          ))}
        </div>
      </div>
    );
  }

  // time-grid: ช่องแรกเวลา ตามด้วยวันของสัปดาห์ (หรือวันเดียวสำหรับ day)
  renderCalGrid() {
    const todayIso = this.isoOf(new Date());
    const dates = this.calPeriodDates();
    const dateIsos = dates.map(this.isoOf);
    const events = this.state.cal_data.filter((e) => dateIsos.includes(e.appointment_date));

    const hrs = events.map((e) => this.startHourOf(e.appointment_time)).filter((h) => h != null);
    const minH = Math.min(9, ...(hrs.length ? hrs : [9]));
    const maxH = Math.max(17, ...(hrs.length ? hrs : [17]));
    const rows = [];
    for (let h = minH; h <= maxH; h++) rows.push(h);

    return (
      <div className="table-responsive">
        <table className="table table-bordered mb-0" style={{ tableLayout: "fixed" }}>
          <thead>
            <tr>
              <th className="text-secondary text-13 text-center" style={{ width: "70px" }}>{t("svp_time")}</th>
              {dates.map((d) => {
                const iso = this.isoOf(d);
                const isToday = iso === todayIso;
                return (
                  <th key={iso} className="text-center">
                    <div className="text-secondary text-13">{t(this.weekdayKeys[d.getDay()])}</div>
                    <div className={`fw-bold text-18 ${isToday ? "text-primary" : "text-dark"}`}>
                      {isToday ? (
                        <span className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary text-white" style={{ width: 28, height: 28, fontSize: 14 }}>{d.getDate()}</span>
                      ) : (
                        d.getDate()
                      )}
                    </div>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {rows.map((h) => (
              <tr key={h} style={{ height: "70px" }}>
                <td className="text-secondary text-12 text-center align-middle">{String(h).padStart(2, "0")}:00</td>
                {dates.map((d) => {
                  const iso = this.isoOf(d);
                  const cell = events.filter((e) => e.appointment_date === iso && this.startHourOf(e.appointment_time) === h);
                  return (
                    <td key={iso} className="p-1 align-top">
                      {cell.map((item) => {
                        const col = this.eventColors[this.calColor(item.objective?.name)];
                        return (
                          <div key={item.uid} className="rounded-2 px-2 py-1 mb-1 pointer" style={{ backgroundColor: col.bg, borderLeft: `3px solid ${col.bar}` }} onClick={() => this.openEdit(item)}>
                            <div className="fw-bold text-12" style={{ color: col.text }}>
                              {(item.appointment_time || "").slice(0, 5)} {this.customerLabel(item)}
                            </div>
                            <div className="text-11 text-secondary text-truncate">{item.objective?.name || "-"}</div>
                          </div>
                        );
                      })}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  // month grid (อา-ส, 6 สัปดาห์)
  renderCalMonth() {
    const todayIso = this.isoOf(new Date());
    const anchor = this.parseIso(this.state.cal_anchor);
    const firstOfMonth = new Date(anchor.getFullYear(), anchor.getMonth(), 1);
    const gridStart = this.addDays(firstOfMonth, -firstOfMonth.getDay()); // ย้อนไปวันอาทิตย์
    const weeks = [];
    for (let w = 0; w < 6; w++) weeks.push([0, 1, 2, 3, 4, 5, 6].map((i) => this.addDays(gridStart, w * 7 + i)));

    const eventsOf = (iso) => this.state.cal_data.filter((e) => e.appointment_date === iso);

    return (
      <div className="table-responsive">
        <table className="table table-bordered mb-0" style={{ tableLayout: "fixed" }}>
          <thead>
            <tr>
              {this.weekdayKeys.map((k) => (
                <th key={k} className="text-center text-secondary text-13">{t(k)}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {weeks.map((week, wi) => (
              <tr key={wi} style={{ height: "96px" }}>
                {week.map((d) => {
                  const iso = this.isoOf(d);
                  const inMonth = d.getMonth() === anchor.getMonth();
                  const isToday = iso === todayIso;
                  const evs = eventsOf(iso);
                  return (
                    <td key={iso} className="p-1 align-top" style={{ backgroundColor: inMonth ? "#fff" : "#F8FAFC" }}>
                      <div className={`text-13 mb-1 ${isToday ? "fw-bold text-primary" : inMonth ? "text-dark" : "text-secondary"}`}>
                        {isToday ? (
                          <span className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary text-white" style={{ width: 22, height: 22, fontSize: 12 }}>{d.getDate()}</span>
                        ) : (
                          d.getDate()
                        )}
                      </div>
                      {evs.slice(0, 3).map((item) => {
                        const col = this.eventColors[this.calColor(item.objective?.name)];
                        return (
                          <div key={item.uid} className="rounded-1 px-1 mb-1 pointer text-truncate" style={{ backgroundColor: col.bg, borderLeft: `3px solid ${col.bar}`, fontSize: "11px", color: col.text }} title={`${(item.appointment_time || "").slice(0, 5)} ${this.customerLabel(item)}`} onClick={() => this.openEdit(item)}>
                            {(item.appointment_time || "").slice(0, 5)} {this.customerLabel(item)}
                          </div>
                        );
                      })}
                      {evs.length > 3 && <div className="text-secondary" style={{ fontSize: "11px" }}>+{evs.length - 3}</div>}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  // ============================================================
  // CREATE / EDIT MODAL
  // ============================================================
  renderCreateModal() {
    const s = this.state;
    const isProspect = s.customer_type === "prospect";
    const detail = s.customer_map[s.f_customer_id];
    const now = new Date();
    const todayIso = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;

    return (
      <Modal
        size="lg"
        show={s.modal_create || s.modal_update}
        onHide={this.closeModal}
        centered
        contentClassName="border-0 rounded-4 overflow-hidden shadow-lg bg-light"
      >
        <Modal.Header className="bg-white border-bottom px-4 py-3" closeButton>
          <div className="d-flex align-items-center">
            <span className="icon me-2 text-primary text-20">{IC.calendar}</span>
            <div>
              <h5 className="fw-bold mb-0 text-dark">{s.modal_update ? t("edit") : t("svp_new_plan")}</h5>
              <div className="text-secondary text-12 mt-1">{t("svp_modal_sub")}</div>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body className="p-4" style={{ maxHeight: "75vh", overflowY: "auto" }}>
          {/* Section 1: Customer */}
          <div className="bg-white rounded-4 p-4 mb-3 shadow-sm">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 className="fw-bold text-dark mb-0 d-flex align-items-center">
                <span className="icon me-2 text-primary">{IC.user}</span> {t("svp_sec1")}
              </h6>
            </div>

            {/* Sales */}
            <div className="mb-3">
              <label className="form-label text-dark fw-bold text-14">{t("svp_col_sales")} <span className="text-danger">*</span></label>
              <Select
                className="form-control rounded-3 text-dark bg-white"
                options={s.data_sales}
                value={s.f_sale_id}
                onChange={(value) => this.setState({ f_sale_id: value })}
                placeholder={t("svp_ph_sales")}
              />
            </div>

            <label className="form-label text-dark fw-bold text-14">{t("svp_customer_type")} <span className="text-danger">*</span></label>
            <div className="d-flex gap-2 mb-3">
              <button
                className={`btn flex-fill py-2 fw-bold d-flex align-items-center justify-content-center ${!isProspect ? "btn-primary text-white" : "btn-white border text-dark"}`}
                onClick={() => this.setState({ customer_type: "existing" })}
              >
                <span className="icon me-2">{IC.users}</span> {t("svp_existing")}
              </button>
              <button
                className={`btn flex-fill py-2 fw-bold d-flex align-items-center justify-content-center ${isProspect ? "btn-primary text-white" : "btn-white border text-dark"}`}
                onClick={() => this.setState({ customer_type: "prospect" })}
              >
                <span className="icon me-2">{IC.sparkle}</span> {t("svp_prospect")}
              </button>
            </div>

            {isProspect ? (
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label text-dark fw-bold text-14">{t("svp_company")} <span className="text-danger">*</span></label>
                  <input type="text" className="form-control" value={s.f_customer_name} placeholder={t("svp_company_ph")} onChange={(e) => this.setState({ f_customer_name: e.target.value })} />
                </div>
                <div className="col-md-6">
                  <label className="form-label text-dark fw-bold text-14">{t("svp_biz_type")}</label>
                  <input type="text" className="form-control" value={s.f_business_type} onChange={(e) => this.setState({ f_business_type: e.target.value })} />
                </div>
                <div className="col-md-6">
                  <label className="form-label text-dark fw-bold text-14">{t("svp_contact")}</label>
                  <input type="text" className="form-control" value={s.f_contact_name} placeholder={t("svp_contact_ph")} onChange={(e) => this.setState({ f_contact_name: e.target.value })} />
                </div>
                <div className="col-md-6">
                  <label className="form-label text-dark fw-bold text-14">{t("svp_phone")}</label>
                  <input type="text" className="form-control" value={s.f_contact_phone} placeholder="08X-XXX-XXXX" onChange={(e) => this.setState({ f_contact_phone: e.target.value })} />
                </div>
                <div className="col-12">
                  <label className="form-label text-dark fw-bold text-14">{t("svp_address")}</label>
                  <textarea className="form-control" rows="2" value={s.f_address} placeholder={t("svp_address_ph")} onChange={(e) => this.setState({ f_address: e.target.value })}></textarea>
                </div>
              </div>
            ) : (
              <>
                <div className="mb-3">
                  <label className="form-label text-dark fw-bold text-14">{t("svp_select_customer")} <span className="text-danger">*</span></label>
                  <Select
                    className="form-control rounded-3 text-dark bg-white"
                    options={s.data_customers}
                    onSearch={this.SearchCustomers}
                    value={s.f_customer_id}
                    onChange={(value, item) => {
                      this.pinCustomer(item);
                      this.setState({ f_customer_id: value });
                    }}
                    placeholder={t("svp_ph_pick_customer")}
                  />
                </div>
                {detail ? (
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label text-dark fw-bold text-14">{t("svp_company")}</label>
                      <input type="text" className="form-control bg-light" value={detail.full_name_th || detail.full_name_en || ""} readOnly />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label text-dark fw-bold text-14">{t("svp_phone")}</label>
                      <input type="text" className="form-control bg-light" value={detail.phone || detail.mobile_phone || "-"} readOnly />
                    </div>
                    <div className="col-12">
                      <label className="form-label text-dark fw-bold text-14">{t("svp_address")}</label>
                      <textarea className="form-control bg-light" rows="2" value={detail.address || "-"} readOnly></textarea>
                    </div>
                    <div className="col-12">
                      <div className="text-secondary text-12 d-flex align-items-center">
                        <span className="icon me-2 text-primary">{IC.info}</span> {t("svp_autofill_hint")}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="border rounded-3 p-4 text-center bg-light text-secondary text-13">{t("svp_pick_customer_empty")}</div>
                )}
              </>
            )}
          </div>

          {/* Section 2: Appointment */}
          <div className="bg-white rounded-4 p-4 mb-3 shadow-sm">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 className="fw-bold text-dark mb-0 d-flex align-items-center">
                <span className="icon me-2 text-primary">{IC.calendar}</span> {t("svp_sec2")}
              </h6>
            </div>

            <div className="row g-3">
              <div className="col-md-4">
                <label className="form-label text-dark fw-bold text-14">{t("svp_visit_date")} <span className="text-danger">*</span></label>
                <DatePicker
                  type="th"
                  className="form-control"
                  min={todayIso}
                  value={s.f_appointment_date}
                  onChange={(val) => this.setState({ f_appointment_date: val })}
                />
              </div>
              <div className="col-md-4">
                <label className="form-label text-dark fw-bold text-14">{t("svp_start_time")}</label>
                <input
                  type="time"
                  className="form-control"
                  value={s.f_appointment_time}
                  onChange={(e) => this.setState({ f_appointment_time: e.target.value, ...(s.f_appointment_time_end && s.f_appointment_time_end <= e.target.value ? { f_appointment_time_end: "" } : {}) })}
                />
              </div>
              <div className="col-md-4">
                <label className="form-label text-dark fw-bold text-14">{t("svp_end_time")}</label>
                <input
                  type="time"
                  className="form-control"
                  min={s.f_appointment_time || undefined}
                  disabled={!s.f_appointment_time}
                  value={s.f_appointment_time_end}
                  onChange={(e) => this.setState({ f_appointment_time_end: e.target.value })}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label text-dark fw-bold text-14">{t("svp_objective")} <span className="text-danger">*</span></label>
                <Select
                  className="form-control rounded-3 text-dark bg-white"
                  options={s.data_objectives}
                  value={s.f_objective_id}
                  onChange={(value) => this.setState({ f_objective_id: value })}
                  placeholder={t("svp_ph_objective")}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label text-dark fw-bold text-14">{t("svp_machine")}</label>
                <input type="text" className="form-control" value={s.f_reference} onChange={(e) => this.setState({ f_reference: e.target.value })} />
              </div>
              {/* สถานะถูกซ่อนไว้ — สร้างใหม่ default เป็น "รอเข้าพบ" (waiting) อัตโนมัติ */}
              <div className="col-12">
                <label className="form-label text-dark fw-bold text-14">{t("svp_remark")} <span className="text-danger">*</span></label>
                <textarea className="form-control" rows="3" value={s.f_description} placeholder={t("svp_remark_ph")} onChange={(e) => this.setState({ f_description: e.target.value })}></textarea>
                <div className="d-flex justify-content-between">
                  <div className="text-secondary text-12 mt-1">{t("svp_remark_hint")}</div>
                  <div className={`text-12 mt-1 fw-bold ${s.f_description.trim().length >= 30 ? "text-success" : "text-danger"}`}>
                    {s.f_description.trim().length} / 30
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="bg-white border-top px-4 py-3 d-flex justify-content-end gap-2">
          <button className="btn btn-white border text-dark px-4 fw-bold" onClick={this.closeModal}>{t("cancel")}</button>
          {(!s.uid ? can("sale-planning.create") : can("sale-planning.update")) ? (
          <button className="btn btn-primary px-4 fw-bold d-flex align-items-center shadow-sm" onClick={this.handleSave}>
            <span className="icon me-2">{IC.save}</span> {t("save")}
          </button>
          ) : null}
        </Modal.Footer>
      </Modal>
    );
  }
}
